<template>
  <div>
    <b-modal
      v-model="show"
      hide-footer
      hide-header-close
      :title="mediaWithDetails[index].name"
      size="xl"
      :hide-header="images.length"
      @hidden="closeGallery"
    >
      <div class="image-header"
        v-if="images.length">
        <div class="image-actions">
          <i class="fa fa-download" @click="download" aria-hidden="true"></i>
          <i class="fa fa-share-alt" @click="share" ></i>
        </div>
        <h3 class="current-image-index">
          {{ index + 1 }} / {{ images.length }}
        </h3>
        <div></div>
      </div>
      <b-container v-if="images.length">
        <b-row>
          <i class="fa fa-angle-left" v-if="index" @click="goLeft"></i>
          <img :src="images[index]" alt="img" />
          <i
            class="fa fa-angle-right"
            v-if="index + 1 < images.length"
            @click="goRight"
          ></i>
          <div class="close-btn-background"></div>
          <i :class="`fa fa-times-circle is-image`" @click="closeGallery"></i>
        </b-row>
        <div class="image-dots-container">
          <div
            v-for="(image, i) in images"
            :key="i"
            class="image-dot"
            :class="{ active: i === index }"
            @click="index = i"
          ></div>
        </div>
        <hr/>
      </b-container>
      <b-container v-else-if="videos.length">
        <b-row>
          <i class="fa fa-angle-left" v-if="index" @click="goLeft"></i>
          <div class="video-archive" v-if="index != null">
            <video-embed
              :src="videos[index]"
              v-if="getHostName(videos[index])"
            ></video-embed>
          </div>
          <i
            class="fa fa-angle-right"
            v-if="index + 1 < videos.length"
            @click="goRight"
          ></i>
          <div class="close-btn-background"></div>
          <i class="fa fa-times-circle" @click="closeGallery"></i>
        </b-row>
      </b-container>
      <GalleryActions
        ref="galleryActions"
        v-if="!$route.name.startsWith('Public')"
        :image="images[index]"
        :video="videos[index]"
        :details="mediaWithDetails[index]"
      />
    </b-modal>
  </div>
</template>

<script>
import GalleryActions from './GalleryActions.vue';

export default {
  name: 'Gallery',
  components: {
    GalleryActions,
  },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    videos: {
      type: Array,
      default: () => [],
    },
    startIndex: {
      type: Number,
      default: null,
    },
    mediaWithDetails: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: true,
      index: null,
    };
  },
  mounted() {
    this.index = this.startIndex;
  },
  beforeMount() {
    window.addEventListener('keydown', this.handleKeydown, null);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleKeydown(e) {
      switch (e.keyCode) {
        case 37:
          this.goLeft();
          break;
        case 39:
          this.goRight();
          break;
        default:
          break;
      }
    },
    closeGallery() {
      this.show = false;
      this.$emit('close');
    },
    goLeft() {
      if (this.index) {
        this.index = this.index - 1;
      }
    },
    goRight() {
      if (this.images.length && this.index + 1 < this.images.length) {
        this.index = this.index + 1;
      } else if (this.videos.length && this.index + 1 < this.videos.length) {
        this.index = this.index + 1;
      }
    },
    getHostName(url) {
      let videoType = '';
      const regexYoutube = new RegExp(
        /(?:https?:\/\/)?(?:www\.)?youtu\.?be(?:\.com)?\/?.*(?:watch|embed)?(?:.*v=|v\/|\/)([\w\-_]+)&?/,
      );
      const regexVimeo = new RegExp(
        /(?:http|https)?:?\/?\/?(?:www\.)?(?:player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/,
      );
      const isYoutubeUrl = regexYoutube.test(url);
      const isVimeoUrl = regexVimeo.test(url);
      if (isYoutubeUrl) videoType = 'youtube';
      if (isVimeoUrl) videoType = 'vimeo';
      return videoType;
    },
    share() {
      this.$refs.galleryActions.shareImage();
    },
    download() {
      this.$refs.galleryActions.downloadImage();
    },
  },
};
</script>

<style scoped>
/deep/ .modal-content {
  border-radius: 0 10px 10px 10px;
}
/deep/ .modal-body {
  padding: 0 !important;
}
.video-archive {
  width: 100%;
}
hr {
  background-color: black;
  margin: 0 -15px;
}

.fa-times-circle {
  position: absolute;
  top: -50px;
  right: 10px;
  color: #bd9d5f;
}
.fa-times-circle.is-image {
  top: 6px;
  font-size: 30px;
}
img {
  margin: auto;
  width: 100%;
  height: 700px;
  object-fit: contain;
}
i {
  font-size: 40px;
  cursor: pointer;
}
.fa-angle-left,
.fa-angle-right {
  font-weight: bolder;
  position: absolute;
  color: #ebebeb;
}
.fa-angle-left {
  top: 50%;
  left: 5%;
  transform: translateY(-50%);
}
.fa-angle-right {
  top: 50%;
  right: 5%;
  transform: translateY(-50%);
}
@media (max-width: 1024px) {
  img {
    height: 500px;
  }
}
@media (max-width: 500px) {
  img {
    height: 300px;
  }
}
.image-header {
  display: flex;
  justify-content: space-between;
}
.image-actions {
  display: flex;
  column-gap: 10px;
  padding: 10px;
  position: relative;
  padding: 15px;
}
.image-actions i {
  font-size: 18px !important;
  color: #bd9d5f;
  cursor: pointer;
}
.current-image-index {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 18px;
  margin: 0;
  padding: 0;
  top: 10px;
}
.image-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ebebeb;
  display: inline-block;
  margin: 5px;
  cursor: pointer;
}
.image-dot.active {
  background-color: #bd9d5f;
}
.image-dots-container {
  text-align: center;
  margin: 0 -15px;
}
</style>
